import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import { StaggerGroup, StaggerItem, Reveal } from "../components/Reveal";
import { BLOG_POSTS } from "../data/content";
import { ArrowUpRight } from "lucide-react";

export default function Blog() {
  const [featured, ...rest] = BLOG_POSTS;

  return (
    <div data-testid="blog-page">
      <PageHeader
        overline="The grooh journal"
        title="Ideas for better"
        highlight="communities."
        subtitle="Playbooks, guides and stories to help your committee run a happier, smoother society."
        testid="blog-header"
      />

      {/* Featured post */}
      <section className="pb-16">
        <div className="container-x">
          <Reveal>
            <Link
              to={`/blog/${featured.slug}`}
              className="group grid md:grid-cols-2 gap-8 items-center bg-brand-light rounded-3xl overflow-hidden border-2 border-transparent hover:border-black transition-all duration-300 hover:shadow-hard-sm"
              data-testid="blog-featured"
            >
              <div className="overflow-hidden h-64 md:h-[420px]">
                <img
                  src={`${featured.cover}?auto=format&fit=crop&w=1000&q=80`}
                  alt={featured.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-8 md:p-12">
                <div className="flex items-center gap-3 text-sm font-semibold mb-4">
                  <span className="bg-[#0033A2] text-white rounded-full px-3 py-1 text-xs uppercase tracking-wide">
                    Featured · {featured.category}
                  </span>
                  <span className="text-black/50">{featured.date} · {featured.read}</span>
                </div>
                <h2 className="font-heading font-extrabold text-3xl md:text-4xl tracking-tight leading-tight group-hover:text-[#0033A2] transition-colors">
                  {featured.title}
                </h2>
                <p className="mt-4 text-black/65 font-medium text-lg leading-relaxed">
                  {featured.excerpt}
                </p>
                <span className="mt-6 inline-flex items-center gap-2 font-heading font-bold text-[#0033A2]">
                  Read article <ArrowUpRight size={18} strokeWidth={2.5} />
                </span>
              </div>
            </Link>
          </Reveal>
        </div>
      </section>

      {/* Grid */}
      <section className="pb-24 md:pb-32">
        <div className="container-x">
          <StaggerGroup className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {rest.map((p, i) => (
              <StaggerItem key={p.slug}>
                <Link
                  to={`/blog/${p.slug}`}
                  className="group block h-full"
                  data-testid={`blog-card-${i}`}
                >
                  <div className="h-full bg-white rounded-3xl overflow-hidden border-2 border-black shadow-hard-sm transition-all duration-300 group-hover:-translate-y-2 group-hover:shadow-hard">
                    <div className="overflow-hidden h-52">
                      <img
                        src={`${p.cover}?auto=format&fit=crop&w=800&q=80`}
                        alt={p.title}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>
                    <div className="p-7">
                      <div className="flex items-center gap-3 text-sm font-semibold text-[#0033A2] mb-3">
                        <span className="bg-brand-light rounded-full px-3 py-0.5 text-xs uppercase tracking-wide">
                          {p.category}
                        </span>
                        <span className="text-black/50">{p.read}</span>
                      </div>
                      <h3 className="font-heading font-bold text-xl tracking-tight leading-snug group-hover:text-[#0033A2] transition-colors">
                        {p.title}
                      </h3>
                      <p className="mt-3 text-black/60 font-medium text-sm leading-relaxed line-clamp-2">
                        {p.excerpt}
                      </p>
                    </div>
                  </div>
                </Link>
              </StaggerItem>
            ))}
          </StaggerGroup>
        </div>
      </section>
    </div>
  );
}
